import { Button } from '@workspace/ui/components/button';
import { ArrowRight, Check } from 'lucide-react';
import { m } from '~/paraglide/messages.js';

type Props = {
  onActivate: () => void;
  onSkip: () => void;
  isSubmitting: boolean;
};

export function ActivateCardComponent({
  onActivate,
  onSkip,
  isSubmitting,
}: Props) {
  const benefits = [
    m['onboarding.activate_card.benefit_1'](),
    m['onboarding.activate_card.benefit_2'](),
    m['onboarding.activate_card.benefit_3'](),
    m['onboarding.activate_card.benefit_4'](),
    m['onboarding.activate_card.benefit_5'](),
  ];

  return (
    <div className="w-full max-w-md space-y-8">
      <div className="relative mx-auto w-full max-w-xs">
        <img
          src="/card.png"
          alt="Bloque VISA card"
          className="w-full drop-shadow-2xl"
        />
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-bold text-foreground">
          {m['onboarding.activate_card.card_title']()}
        </h3>

        <ul className="space-y-2.5">
          {benefits.map((benefit) => (
            <li key={benefit} className="flex items-start gap-3">
              <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10">
                <Check className="h-3 w-3 text-primary" />
              </div>
              <span className="text-sm text-muted-foreground">{benefit}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="space-y-3">
        <Button
          onClick={onActivate}
          disabled={isSubmitting}
          className="flex w-full items-center justify-center gap-2 py-6 font-semibold transition-all"
        >
          {isSubmitting
            ? m['common.loading']()
            : m['onboarding.activate_card.verify_and_activate']()}
          {!isSubmitting && <ArrowRight className="h-5 w-5" />}
        </Button>

        <button
          type="button"
          onClick={onSkip}
          disabled={isSubmitting}
          className="w-full py-2 text-center text-sm text-muted-foreground transition-colors hover:text-foreground disabled:opacity-50"
        >
          {m['onboarding.activate_card.skip']()}
        </button>
      </div>
    </div>
  );
}
